import Vue from 'vue';
import Vuex from 'vuex';
import notesApi from '../api';
import moment from 'moment'
import { Alert } from 'element-ui';

Vue.use(Vuex);

export default {
  state(){
    return {
      allNotes: null,
      maxDateNotes: null,
      maxDateNotesNext: null,
      minDateNotes: null,
      minDateNotesNext: null,
      searchNotes: null,
      calendarNotes: null,
      notes: null,
      rangeNotes: null
      // monthView: null,
      // weekView: null,
      // dayView: null
    }
  },
  getters: {
    GET_NOTES: state => {
      return state.notes
    },
    GET_MAX_DATE_NOTES: state => {
      return state.maxDateNotes;
    },
    GET_MIN_DATE_NOTES: state => {
      return state.minDateNotes;
    },
    GET_ALL_NOTES: state => {
      if (state.maxDateNotes && state.minDateNotes) {
        return state.maxDateNotes.results.concat(state.minDateNotes.results)
      }
    },
    GET_SEARCH_NOTES: state => {
      return state.searchNotes
    },
    GET_CALENDAR_NOTES: state => {
      if(state.calendarNotes) {
        return state.calendarNotes.results
      }
    },
    GET_NEXT_FROM_MIN: state => {
      if (state.minDateNotes && state.minDateNotes.next) {
        return state.minDateNotes.next
      }
    },
    GET_NEXT_FROM_MAX: state => {
      if (state.maxDateNotes && state.maxDateNotes.next ) {
        return state.maxDateNotes.next
      }
    },
    GET_RANGE_NOTES: state => {
      if(state.rangeNotes) {
        return state.rangeNotes.results
      }
    }
  },
  mutations: {
    SET_MAX_DATE: (state, payload) => {
      state.maxDateNotes = payload;
      state.maxDateNotesNext = state.maxDateNotes.next
    },
    SET_MIN_DATE: (state, payload) => {
      state.minDateNotes = payload;
      state.minDateNotesNext = state.minDateNotes.next
    },
    SET_MIN_DATE_NOTE: (state, payload) => {
      state.minDateNotes[payload] = payload;
    },
    WRITE_NOTE: (state, payload) => {
      state.rangeNotes.results.push(payload);
      state.calendarNotes.results.push(payload);
    },
    UPDATE_NOTE: (state, payload) => {
      state.rangeNotes.results.map(note => {
        if (note.id === payload.id) {
          note = payload;
        }
      });
      // state.maxDateNotes.results.map(note => {
      //   if (note.id === payload.id) {
      //     note = payload;
      //   }
      // });
      // state.minDateNotes.results.map(note => {
      //   if (note.id === payload.id) {
      //     note = payload;
      //   }
      // });
    },
    ADD_NOTES: (state, payload) => {
      state.allNotes.concat(payload);
    },
    // // SET_NEXT_PAGE_FOR_MIN_DATE: (state, payload) => {
    // //   let _out = state.minDateNotes.results.concat(payload.results);
    // //   state.minDateNotes.results = _out;
    // //   state.minDateNotes.next = payload.next;
    // //   state.minDateNotes.previous = payload.previous;
    // // },
    // SET_NEXT_PAGE_FOR_MAX_DATE: (state, payload) => {
    //   let _out = state.maxDateNotes.results.concat(payload.results);
    //   state.maxDateNotes.results = _out;
    //   state.maxDateNotes.next = payload.next;
    //   state.maxDateNotes.previous = payload.previous;
    // },
    INIT: (state, payload) => {
      state.notes = payload
      // state.minDateNotes = payload['min_date'];
      // state.maxDateNotes = payload['max_date'];
    },
    INIT_FOR_FULL_NOTES: (state, payload) => {
      state.minDateNotes = payload['min_date'];
      state.maxDateNotes = payload['max_date'];
    },
    DELETE_NOTE: (state, payload) => {
      state.maxDateNotes.results.map(note => {
        if (note.id === payload) {
          let _indexOfDeletedNote = state.maxDateNotes.results.indexOf(note)
          state.maxDateNotes.results.splice(_indexOfDeletedNote,1)
        }
      });
      state.minDateNotes.results.map(note => {
        if (note.id === payload) {
          let _indexOfDeletedNote = state.minDateNotes.results.indexOf(note)
          state.minDateNotes.results.splice(_indexOfDeletedNote, 1)
        }
      });
      state.calendarNotes.results.map(note => {
        if (note.id === payload) {
          let _indexOfDeletedNote = state.calendarNotes.results.indexOf(note)
          state.calendarNotes.results.splice(_indexOfDeletedNote, 1)
        }
      });
    },
    SEARCH_NOTES: (state, payload) => {
      state.searchNotes = payload
    },
    SET_CALENDAR_NOTES: (state, payload) => {
      state.calendarNotes = payload
    },
    ADD_CALENDAR_NOTE: (state, payload) => {
      state.calendarNotes.results.push(payload)
    },
    SET_RANGE_NOTES: (state, payload) => {
      state.rangeNotes = payload
    }
  },
  actions: {
    WRITE_NOTE: async (context, payload) => {
      await notesApi.setNote(payload).then(resp => {
        context.commit('WRITE_NOTE', resp);
      });
    },
    UPDATE_NOTE: async (context, payload) => {
      await notesApi.updateNote(payload).then(resp => {
        context.commit('UPDATE_NOTE', resp);
      });
    },
    SET_MAX_DATE: async (context, payload) => {
      await notesApi.getMaxDate(payload).then(resp => {
        context.commit('SET_MAX_DATE', resp);
      });
    },
    SET_MIN_DATE: async (context, payload) => {
      await notesApi.getMinDate(payload).then(resp => {
        context.commit('SET_MIN_DATE', resp);
      });
    },
    ADD_NOTES: async (context, payload) => {
      await notesApi.addNotes(payload).then(resp => {
        context.commit('SET_NOTES', resp);
      });
    },
    DELETE_NOTE: async (context, payload) => {
      await notesApi.deleteNote(payload).then(res => {
        context.commit('DELETE_NOTE', payload);
      });
    },
    SET_NEXT_PAGE_FOR_MIN_DATE: async (context, payload) => {
      await notesApi.getNextPage(payload).then(res => {
        context.commit('SET_MIN_DATE', res);
      });
    },
    SET_NEXT_PAGE_FOR_MAX_DATE: async (context, payload) => {
      await notesApi.getNextPage(payload).then(res => {
        context.commit('SET_MAX_DATE', res);
      });
    },
    INIT: async (context, payload) => {
      await notesApi.getNotesByRange(payload, false).then(res => {
        context.commit('SET_RANGE_NOTES', res);
      });
    },
    INIT_FOR_FULL_NOTES: async (context, payload) => {
      await notesApi.init(payload).then(res => {
        context.commit('INIT_FOR_FULL_NOTES', res);
      });
    },
    SEARCH_NOTES: async (context, payload) => {
      await notesApi.searchNotes(payload).then(res => {
        context.commit('SEARCH_NOTES', res)
      })
    },
    SET_CALENDAR_NOTES: async(context, payload) => {
      await notesApi.getNotesByRange(payload, true).then(res => {
        context.commit('SET_CALENDAR_NOTES', res)
      })
    },

  
  },

  modules: {}

}



// WEBPACK FOOTER //
// ./src/apps/bpm/notes/store/index.js